module.exports = __webpack_public_path__ + "img/opensans-semibold-webfont.cc3e491b.svg";